import { Either, Failure } from '../../../core/core'
import { dashboardGetEmbedTokens, dashboardGetTokens } from '../../../data/data'
import {
  IDashboardEmbedConfig,
  IDashboardPayload,
  IDashboardSingle,
  IDashboardTokens,
} from '../../interfaces/IDashboard'

import {
  dashboardsGet,
  dashboardsGetOne,
  dashboardsPost,
  orgDashboardLinksGet,
  putDashboard,
  removeDashboard,
  removeDashboards,
} from '../../../data/repositories/dashboards/DashboardsRepository'
import { IDashboard, IDashboardLink, IDashboardResponse } from '../../interfaces/IDashboard'

export async function getDashboardTokens(): Promise<Either<Failure, IDashboardTokens>> {
  return await dashboardGetTokens()
}

export async function getDashboardEmbedTokens(
  config: IDashboardEmbedConfig,
): Promise<Either<Failure, IDashboardTokens>> {
  return await dashboardGetEmbedTokens(config)
}

export async function getDashboardLinks(): Promise<Either<Failure, IDashboardLink[]>> {
  return await orgDashboardLinksGet()
}

export async function getDashboards(query: string): Promise<Either<Failure, IDashboardResponse>> {
  return await dashboardsGet(query)
}

export async function getDashboardById(id: string): Promise<Either<Failure, IDashboardSingle>> {
  return await dashboardsGetOne(id)
}

export async function createDashboard(dashboardPayload: IDashboardPayload): Promise<Either<Failure, IDashboard[]>> {
  return await dashboardsPost(dashboardPayload)
}

export async function deleteDashboardById(id: string): Promise<Either<Failure, IDashboard>> {
  return await removeDashboard(id)
}

export async function deleteDashboards(ids: string[]): Promise<Either<Failure, IDashboard[]>> {
  return await removeDashboards(ids)
}

export async function updatedDashboard(
  id: string,
  dashboardPayload: IDashboardPayload,
): Promise<Either<Failure, IDashboard>> {
  return await putDashboard(id, dashboardPayload)
}
